import * as React from "react";

import { cn } from "@/lib/utils";

function Input({ className, type, value, ...props }: React.ComponentProps<"input">) {
  const resolvedValue =
    type === "number" && (value === 0 || value === "0") ? "" : value;
  return (
    <input
      type={type}
      value={resolvedValue}
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground flex h-11 w-full min-w-0 rounded-md border border-border bg-card px-4 py-2.5 text-base text-foreground shadow-[0_1px_1px_rgb(0_0_0/0.02)] transition-[color,box-shadow,border-color] outline-none hover:border-border file:inline-flex file:h-9 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-60 md:text-sm",
        "focus-visible:border-primary/60 focus-visible:ring-primary/12 focus-visible:ring-4 focus-visible:hover:border-primary/60",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        className
      )}
      {...props}
    />
  );
}

export { Input };
